import { AppHeader } from '@teliaee/telia-megamenu';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import config from '../../config';
import { ILanguageStore } from '../../stores/LanguageStore';
import { IRouteStore } from '../../stores/RouteStore';
import { ISsoStore } from '../../stores/SsoStore';

interface IHeaderContainerProps {
  languageStore?: ILanguageStore;
  routeStore?: IRouteStore;
  ssoStore?: ISsoStore;
}

const HeaderContainer = (props: IHeaderContainerProps): JSX.Element => {
  return (
    <AppHeader
      brand="diil"
      lang={props.languageStore.currentLanguage}
      tier={config.headerEnvironmentName}
      app="selfservice"
      currentPath={props.routeStore.location.pathname}
      loginOptions={props.ssoStore.isSsoFrameVisible ? { authLevel: 2 } : undefined}
      ssoClient={props.ssoStore.ssoClient as any}
      ssoClientState={props.ssoStore.ssoState}
      disableSoftAuth={true}
      onLangChange={(language) => props.routeStore.updateLanguageInPath(language, props.languageStore.defaultLanguage)}
      isSPA={true}
    />
  );
};

export default inject('languageStore', 'routeStore', 'ssoStore')(observer(HeaderContainer));
